var map = {
	"./Bukiety/img1.jpg": 7883,
	"./Bukiety/img2.jpg": 3273,
	"./Bukiety/img3.jpg": 9460,
	"./Bukiety/img4.jpg": 8763,
	"./Bukiety/img5.jpg": 7350,
	"./Bukiety/img6.jpg": 8859,
	"./Bukiety/img7.jpg": 216,
	"./Bukiety/img8.jpg": 8596,
	"./Flowerbox/img1.jpg": 7956,
	"./Flowerbox/img2.jpg": 4015,
	"./Flowerbox/img3.jpg": 7779,
	"./Flowerbox/img4.jpg": 7532,
	"./Flowerbox/img5.jpg": 4791,
	"./Icons/fb-icon.png": 434,
	"./Icons/ig-icon.png": 6693,
	"./Icons/mail-icon.png": 3359,
	"./Icons/phone-icon.png": 3590,
	"./Innekompozycje/20210817_213602.jpg": 9849,
	"./Innekompozycje/20230407_135232.jpg": 6789,
	"./Kosciol/img1.jpg": 6879,
	"./Kosciol/img2.jpg": 5704,
	"./Kosciol/img3.jpg": 8538,
	"./Kosciol/img4.jpg": 9416,
	"./Kwiatomaty/kaufland.jpg": 7786,
	"./Kwiatomaty/miasto.jpg": 1646,
	"./Kwiatomaty/rapsodia.jpg": 5054,
	"./Pracownia/inside1.jpg": 1193,
	"./Pracownia/inside2.jpg": 2585,
	"./Wianki/img1.jpg": 5120,
	"./Wianki/img10.jpg": 7526,
	"./Wianki/img11.jpg": 3458,
	"./Wianki/img2.jpg": 4307,
	"./Wianki/img3.jpg": 5979,
	"./Wianki/img4.jpg": 9908,
	"./Wianki/img5.jpg": 1059,
	"./Wianki/img6.jpg": 5685,
	"./Wianki/img7.jpg": 6740,
	"./Wianki/img8.jpg": 1253,
	"./Wianki/img9.jpg": 7339,
	"./Wieńce/img1.jpg": 482,
	"./Wieńce/img2.jpg": 7771,
	"./Wieńce/img3.jpg": 6686,
	"./Wieńce/img4.jpg": 9479,
	"./logo.jpg": 9845,
	"./logo.png": 7946,
	"./Śluby/img1.jpg": 5201,
	"./Śluby/img2.jpg": 2790,
	"./Śluby/img3.jpg": 1743,
	"./Śluby/img4.jpg": 6588,
	"./Śluby/img5.jpg": 715,
	"./Śluby/img6.jpg": 7943,
	"./Śluby/img7.jpg": 5669,
	"./Śluby/img8.jpg": 8400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;